import { type VariantProps, cva } from "class-variance-authority";

import * as styles from "./Pacman.module.scss";

type PacmanProps = VariantProps<typeof pacmanVariants>;

const pacmanVariants = cva(styles.pacman, {
  variants: {
    tone: {
      light: styles.light,
      dark: styles.dark,
    },
    size: {
      default: styles.sizeDefault,
      sm: styles.sizeSm,
    },
  },
  defaultVariants: {
    tone: "light",
    size: "default",
  },
});

const Pacman = ({ tone, size }: PacmanProps) => {
  return (
    <div
      data-testid={`pacman`}
      data-tone={tone || "light"}
      data-size={size || "default"}
      className={pacmanVariants({ tone, size })}
    >
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

Pacman.displayName = "Pacman";

export { Pacman };
